import { render } from "./OrganizationMemberDashboard.vue?vue&type=template&id=555ea3ec"
import script from "./OrganizationMemberDashboard.vue?vue&type=script&lang=js"
export * from "./OrganizationMemberDashboard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__